module.exports = __webpack_public_path__ + "img/wind.4680a871.svg";